import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  Button,
  Form,
  Modal,
  ModalBody,
  Input,
  Label,
  FormGroup,
  FormFeedback,
} from "reactstrap";

const initialState = {
  userId: "",
  date: "",
  note: "",
};

const formatDateForInput = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString().split("T")[0];
};

const getSelectedOption = (options, value) =>
  options.find((opt) => String(opt?.value) === String(value)) || null;

const ClientAppreciationAddEditModal = ({
  clientAppreciationAddEditModalOpen,
  setclientAppreciationAddEditModalOpen,
  editableData = null,
  onSubmit,
  userOptions = [],
}) => {
  const [formData, setFormData] = useState({ ...initialState });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (editableData) {
      const matchedUserId =
        editableData?.userId ||
        editableData?.forUserId ||
        (userOptions.find(
          (opt) =>
            String(opt?.label || "").toLowerCase().trim() ===
            String(editableData?.user || "").toLowerCase().trim()
        )?.value || "");

      setFormData({
        userId: matchedUserId,
        date: formatDateForInput(editableData?.date),
        note: editableData?.note || editableData?.notes || "",
      });
    } else {
      setFormData({ ...initialState });
    }
    setErrors({});
  }, [editableData, clientAppreciationAddEditModalOpen, userOptions]);

  const closeModal = () => {
    setclientAppreciationAddEditModalOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleUserSelectChange = (option) => {
    setFormData((prev) => ({ ...prev, userId: option?.value || "" }));
    if (errors.userId) {
      setErrors((prev) => ({ ...prev, userId: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.userId) {
      newErrors.userId = "User is required.";
    }
    if (!formData.date) {
      newErrors.date = "Date is required.";
    }
    if (!String(formData.note || "").trim()) {
      newErrors.note = "Note is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validateForm()) return;
    const selectedUserOption = getSelectedOption(userOptions, formData.userId);
    const selectedUserName = selectedUserOption?.label || formData.userId || "";

    if (typeof onSubmit === "function") {
      onSubmit({
        ...editableData,
        userId: formData.userId,
        user: selectedUserName,
        date: formData.date,
        note: formData.note,
      });
    }
    closeModal();
  };

  return (
    <Modal
      isOpen={clientAppreciationAddEditModalOpen}
      toggle={closeModal}
      backdrop="static"
      size="md"
      className="modal-full-height"
      centered
    >
      <ModalBody className="p-4" style={{ maxHeight: "95vh", overflowY: "auto" }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="fw-bold mb-0">{editableData ? "Edit" : "Create"} Client Appreciation</h5>
          <Button close onClick={closeModal} />
        </div>
        <hr />

        <Form>
          <FormGroup>
            <Label>
              User <span className="text-danger">*</span>
            </Label>
              <Select
                options={userOptions}
                className="select2-selection"
                placeholder="Select User"
                value={getSelectedOption(userOptions, formData.userId)}
                onChange={handleUserSelectChange}
                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                menuPosition="fixed"
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
            {errors.userId ? <small className="text-danger">{errors.userId}</small> : null}
          </FormGroup>

          <FormGroup>
            <Label>
              Date <span className="text-danger">*</span>
            </Label>
            <Input
              type="date"
              name="date"
              value={formData.date}
              invalid={!!errors.date}
              onChange={handleChange}
            />
            <FormFeedback>{errors.date}</FormFeedback>
          </FormGroup>

          <FormGroup>
            <Label>
              Note <span className="text-danger">*</span>
            </Label>
            <Input
              type="text"
              name="note"
              value={formData.note}
              invalid={!!errors.note}
              onChange={handleChange}
            />
            <FormFeedback>{errors.note}</FormFeedback>
          </FormGroup>

          <div className="text-end mt-4">
            <Button color="success" onClick={handleSubmit}>
              {editableData ? "Update" : "Save"}
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default ClientAppreciationAddEditModal;
